var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bs-callout bs-callout-primary bs-callout-xs m-b-10 p-10",
      class: { "m-t-0": _vm.andIndex == 0 },
      attrs: { id: "filter-item-and-" + _vm.andIndex }
    },
    [
      !_vm.useInReportingFilters
        ? _c(
            "div",
            _vm._l(_vm.criteria, function(orCriteria, index) {
              return _c("OrCriteria", {
                key: index,
                attrs: {
                  id: "filter-item-or-" + _vm.andIndex + "-" + index,
                  "or-criteria": orCriteria,
                  "is-read-only": _vm.isReadOnly,
                  "is-full-width": _vm.isFullWidth,
                  "is-summary-view": _vm.isSummaryView,
                  "and-index": _vm.andIndex,
                  "or-index": index,
                  "available-tags": _vm.availableTags,
                  "form-name-for-user-settings": _vm.formNameForUserSettings,
                  "has-bulk-comparison-type": _vm.hasBulkComparisonType,
                  "bulk-comparison-index": _vm.bulkComparisonTypeIndex
                },
                on: {
                  change: orCriteria => _vm.handleOrChange(index, orCriteria),
                  removeRule: orIndex => _vm.removeOrCriteria(orIndex)
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.useInReportingFilters
        ? _c(
            "div",
            _vm._l(_vm.criteria, function(orCriteria, index) {
              return _c("ReportingOrCriteria", {
                key: index,
                attrs: {
                  id: "filter-item-or-" + _vm.andIndex + "-" + index,
                  "or-criteria": orCriteria,
                  "is-read-only": _vm.isReadOnly,
                  "is-full-width": _vm.isFullWidth,
                  "is-summary-view": _vm.isSummaryView,
                  "and-index": _vm.andIndex,
                  "or-index": index,
                  "available-tags": _vm.availableTags,
                  "form-name-for-user-settings": _vm.formNameForUserSettings,
                  "values-for-filter": _vm.valuesForReportingFilter,
                  "event-category": _vm.eventCategory
                },
                on: {
                  change: orCriteria => _vm.handleOrChange(index, orCriteria),
                  removeRule: orIndex => _vm.removeOrCriteria(orIndex)
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("button", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "ROUTER_FILTER_ADD_OR",
            expression: "'ROUTER_FILTER_ADD_OR'"
          }
        ],
        staticClass: "btn btn-primary btn-xs m-t-5",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.$emit("addORRule", _vm.andIndex)
          }
        }
      }),
      _vm._v(" "),
      _c("button", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "ROUTER_FILTER_ADD_AND",
            expression: "'ROUTER_FILTER_ADD_AND'"
          }
        ],
        staticClass: "btn btn-primary btn-xs m-l-10 m-t-5",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.$emit("addANDRule", _vm.andIndex)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }